/* eslint-disable no-console */

import { register } from 'register-service-worker';

if (process.env.NODE_ENV === 'production') {
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready() {
      console.log(
        'App is being served from cache by a service worker.\n' +
        'For more details, visit https://goo.gl/AFskqB'
      );
    },
    registered(registration) {
      console.log('Service worker has been registered.');
      
      // Set up periodic sync when online to sync any pending data
      setInterval(() => {
        if (navigator.onLine) {
          // Try to sync data when coming back online
          window.dispatchEvent(new CustomEvent('sync-data'));
        }
      }, 60000); // Check every minute
    },
    cached() {
      console.log('Content has been cached for offline use.');
    },
    updatefound() {
      console.log('New content is downloading.');
    },
    updated(registration) {
      console.log('New content is available; please refresh.');
      // Notify the user about new version
      window.dispatchEvent(new CustomEvent('sw-updated', { detail: registration }));
    },
    offline() {
      console.log('No internet connection found. App is running in offline mode.');
      // Notify the app that we're offline
      window.dispatchEvent(new CustomEvent('app-offline'));
    },
    error(error) {
      console.error('Error during service worker registration:', error);
    }
  });
}